import React from 'react';

function Footer({ data }) {
  const networks = data?.social.map((network) => (
    <li key={network.name}><a href={network.url}><i className={network.className}></i></a></li>
  ));

  return (
    <footer>

      <div className="row">
        <div className="twelve columns">
          <ul className="social-links">
            {networks}
          </ul>

          <ul>
            <li>Modified with love by the Clever Programmer team, Benjamin, & Nicholas Lewis</li>
          </ul>

          <ul className="copyright">
            <li>&copy; {new Date().getFullYear()} Nicholas Lewis</li>
            <li>Design by <a title="Styleshout" href="http://www.styleshout.com/">Styleshout</a></li>
          </ul>

        </div>
        <div id="go-top"><a className="smoothscroll" title="Back to Top" href="#home"><i className="icon-up-open"></i></a></div>
      </div>
    </footer>
  );
}

export default Footer;
